require('./mortgageRequestHeader.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const classnames = require('classnames');

// @ commons
const { FormattedText } = require('core/i18n').i18n;
const { OKBreadcrumb } = require('commonsComponents/OKBreadcrumb');
const { OKLink } = require('commonsComponents/OKLink');
const { EditAlias } = require('commonsComponents/editAlias');
// @ components
const { MortgageRequestViewProcess } = require('components/mortgageRequest/mortgageRequestPanel/mortgageRequestViewProcess/mortgageRequestViewProcess');

class MortgageRequestHeader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isViewProcessModalOpen: false
        };

        this.handleViewProcessModalToogle = this.handleViewProcessModalToogle.bind(this);
    }

    handleViewProcessModalToogle() {
        this.setState(prevState => ({
            isViewProcessModalOpen: !prevState.isViewProcessModalOpen
        }));
    }

    render() {
        const { hidden, titleKey, titleStrings, titleIsEditable, titleEditable, titleEditableAction, breadcrumbConfig, children, subtitleLeft, subtitleRight, isSubtitleLeftCapital } = this.props;
        const classNames = classnames(
            'mortgage-request-header',
            {
                'mortgage-request-header--hidden': hidden
            }
        );
        let titleContent;
        let subtitleContent;
        const headerTitleClasses = classnames('mortgage-request-header__title', {
            'mortgage-request-header__title--oneline': !subtitleLeft
        });
        const headerButtonsSectionClasses = classnames(
            'col-xs-4',
            'mortgage-request-header__buttons-section',
            {
                'col-xs-6 mortgage-request-header__buttons-section--oneline': !subtitleLeft
            }
        );
        const headerSubtitleLeftClasses = classnames('mortgage-request-header__subtitle-left', {
            'mortgage-request-header__subtitle-left--uppercase': isSubtitleLeftCapital
        });

        if (titleIsEditable && !__CONTACT_CENTER__) {
            titleContent = <EditAlias alias={titleEditable} postAlias={titleEditableAction} />;
        } else {
            titleContent = (
                <h1 className={headerTitleClasses}>
                    <FormattedText value={titleKey} injectedStrings={titleStrings} />
                </h1>
            );
        }

        if (subtitleLeft) {
            subtitleContent = (
                <h1 className="mortgage-request-header__subtitle">
                    <span className={headerSubtitleLeftClasses}>
                        {subtitleLeft}
                    </span>
                    <span className="mortgage-request-header__subtitle-right">
                        {subtitleRight}
                    </span>
                </h1>
            );
        }

        const viewProcessModal = this.props.isPanel ?
            (<div>
                <OKLink
                    inverse="true"
                    modifier="complementary"
                    onClick={this.handleViewProcessModalToogle}
                >
                    <FormattedText value="mortgageRequestPanel-viewProcess" />
                </OKLink>
                <MortgageRequestViewProcess
                    isOpen={this.state.isViewProcessModalOpen}
                    onRequestClose={this.handleViewProcessModalToogle}
                />
            </div>) :
            '';

        return (
            <div className={classNames}>
                <div className="mortgage-request-header__breadcrumb-section">
                    <OKBreadcrumb mapping={breadcrumbConfig} />
                </div>
                <div className="row no-gutter mortgage-request-header__middle-section">
                    <div className="col-xs-8 mortgage-request-header__title-section">
                        {titleContent}
                        {viewProcessModal}
                        {subtitleContent}
                    </div>
                    <div className={headerButtonsSectionClasses}>
                        {children}
                    </div>
                </div>
            </div>
        );
    }
}

MortgageRequestHeader.propTypes = {
    breadcrumbConfig: PropTypes.array.isRequired,
    titleKey: PropTypes.string,
    subtitleLeft: PropTypes.string,
    subtitleRight: PropTypes.string,
    children: PropTypes.any,
    titleStrings: PropTypes.array,
    titleIsEditable: PropTypes.bool,
    titleEditable: PropTypes.string,
    titleEditableAction: PropTypes.func,
    hidden: PropTypes.bool,
    isSubtitleLeftCapital: PropTypes.bool,
    isPanel: PropTypes.bool
};

MortgageRequestHeader.defaultProps = {
    subtitleLeft: '',
    subtitleRight: '',
    titleStrings: [],
    titleIsEditable: false,
    hidden: false,
    isSubtitleLeftCapital: true,
    isPanel: false
};

module.exports = MortgageRequestHeader;
